import React from 'react'
import Link from 'next/link'
import styles from './styles.module.scss'

interface BannerProps {
  banner?: {
    imageUrl?: string
    link?: string
    title?: string
    alt?: string
    id?: number
    order?: number
  }
}

export default function BannerContent({ banner }: BannerProps) {
  return (
    <div className={styles.bannerWrapper}>
      {banner?.imageUrl ? (
        <Link href={banner.link || '#'} className={styles.bannerLink}>
          <img
            src={banner.imageUrl}
            width={256}
            height={128}
            alt={banner.alt || ''}
            className={styles.bannerImage}
            loading='lazy'
          />
        </Link>
      ) : (
        <img
          src='/images/svg/dummy_logo.svg'
          width={50}
          height={50}
          className={styles.logo}
          alt='Default logo'
          loading='lazy'
        />
      )}
    </div>
  )
}
